module.exports = __webpack_public_path__ + "static/img/bg-3.13693023.png";